const React = require('react');
import { useEffect, useState } from 'react';
import SharedConstants from '../../../../shared/sharedConstants.js';
import { MPubCardSimple } from './mPubCard';
const AjaxFunctions = require('../ajaxFunctions');

export function LinkPreview(props) {
   let [card, setCard] = useState(null);
   let { title, description, image, idCard, cardType } = props;

   useEffect(() => {
      const getCard = async () => {
         if (!image && idCard && cardType) {
            const card = cardType == SharedConstants.CardType.Evidence
               ? await AjaxFunctions.getEvidenceCardByID(idCard)
               : await AjaxFunctions.getGreySpaceCardByID(idCard);
            setCard(card);
         } else {
            setCard(null);
         }
      }
      getCard()

   }, [props.idCard])

   if (title && description) {
      return (
         <div style={{ borderLeft: `3px solid gray`, maxHeight: '200px', overflow: 'hidden', marginTop: '10px', marginBottom: '10px' }}>
            <div style={{ marginLeft: '1em', maxWidth: '1000px', display: 'inline-block' }}>
               {props.image && <img style={{ float: 'right', maxWidth: '125px', maxHeight: '125px', padding: '1em' }} src={props.image} />}
               <b>{props.title}</b>
               <p style={{ maxWidth: '750px', color: 'rgb(104,104,104)' }}>{props.description.substring(0, 325)}{props.description.length > 325 && '...'}</p>
            </div>
         </div>
      );
   } else if (image) {
      return (
         <div style={{ borderLeft: `3px solid gray`, maxHeight: '200px', overflow: 'hidden', marginTop: '10px', marginBottom: '10px' }}>
            <div style={{ maxWidth: '1000px', display: 'inline-block' }}>
               {<img style={{ float: 'right', maxWidth: '175px', maxHeight: '175px', padding: '1em' }} src={props.image} />}
            </div>
         </div>
      );
   } else if (card != null) {
      return (
         <div style={{ borderLeft: `3px solid gray`, maxHeight: '200px', overflow: 'hidden', marginTop: '10px', marginBottom: '10px' }}>
            <div style={{ marginLeft: '1em', maxWidth: '1000px', display: 'inline-block', transform: 'scale(.8)', transformOrigin: 'left' }}>
               <MPubCardSimple disableLink={true} card={card}></MPubCardSimple>
            </div>
         </div>
      );
   } else {
      return (<div />);
   }
}
